import React from "react";
import { TrainingCenterTab } from "../MainTypes";
import TrainingCenterTabs from "./TrainingCenterTabs";

interface Props {
  activeTab: TrainingCenterTab;
  totalRequired: number;
  totalCompleted: number;
  onClickTab: (tab: TrainingCenterTab) => void;
}

const TrainingCenterExtraHeader = (props: Props) => {
  return (
    <div className="TrainingCenterExtraHeader">
      <TrainingCenterTabs activeTab={props.activeTab} onClick={props.onClickTab} />
    </div>
  );
};

export default TrainingCenterExtraHeader;
